import { Component } from '@angular/core';
import { Router, RouterLinkWithHref } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-notfound',
    imports: [ButtonModule],
    templateUrl: './notfound.component.html',
    styleUrl: './notfound.component.scss'
})
export class NotfoundComponent {

  constructor(private router:Router){

  }
  
  goTo(option: string){
    this.router.navigate([option]);
  }
  
}
